export default "__VITE_ASSET__DsQX$Uwy__"